import { SchemaModifier } from '../types';
import { normalizeContent } from '@fhnw/helpers/DesignSystem/normalizeContent';

const articleModifier: SchemaModifier = (
  content,
  main,
  parts,
  state,
  partial,
) => {
  const category = normalizeContent(content?.news_category, false);
  if (category === 'news') {
    main['additionalType'] = 'NewsArticle';
  } else if (category === 'media_release') {
    main['articleSection'] = 'press-release';
  } else if (category === 'story') {
    main['articleSection'] = 'story';
  } else if (category === 'publication') {
    main['articleSection'] = 'publication';
  }
};

export default articleModifier;
